import { MediaItem, MediaItemFileType } from '../../app/services/mediaItems';
import { DEFAULT_FPS } from '../../utils/timecode';

/**
 * Preview 系画面（Preview.tsx / ComparisonSlide.tsx）で共用する
 * MediaItem 表示用の小ヘルパー。
 */

/**
 * MediaItem の再生・表示用URL（最適化版があればそちらを優先）。
 *
 * 最適化版は変換後ファイル（オーディオ: m4a / 動画: HLS）を指すため、
 * ダウンロード用途には使わないこと。ダウンロードには original_url を使う
 * （MediaPreview には downloadUrl={item.original_url} を渡す）。
 */
export const getMediaUrl = (item: MediaItem) => item.optimized_url || item.original_url;

/**
 * MediaItem の fps を解決する。
 * BE（Lambda ffprobe）の frame_rate を最優先し、未解析の場合はブラウザ側の
 * 実測値（probedFps: HLS マニフェスト / requestVideoFrameCallback 由来）で補完する。
 * どちらも無い動画・オーディオファイルは DEFAULT_FPS で換算する。
 */
export function getMediaFps(
  item: MediaItem | null | undefined,
  probedFps?: number | null,
): number {
  if (item?.frame_rate && item.frame_rate > 0) return item.frame_rate;
  if (probedFps && probedFps > 0) return probedFps;
  return DEFAULT_FPS;
}

/** MediaItem の file_type を MediaPreview の mediaType に変換 */
const FILE_TYPE_TO_MEDIA_TYPE: Record<MediaItemFileType, 'image' | 'video' | 'audio' | 'pdf' | undefined> = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  document: 'pdf',
  other: undefined,
};
export const toMediaType = (fileType: MediaItemFileType) => FILE_TYPE_TO_MEDIA_TYPE[fileType];

/** MediaItem の file_type が audio/video かどうかを判定 */
export function isAudioOrVideoType(fileType: MediaItemFileType): boolean {
  return fileType === 'audio' || fileType === 'video';
}
